(function () {
  const STORAGE_KEY = 'anaajoo_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    document.dispatchEvent(
      new CustomEvent('anaajoo:wishlist-updated', {
        detail: { items }
      })
    );
  }

  function hasProduct(handle) {
    return getWishlist().includes(handle);
  }

  function addProduct(handle) {
    const items = getWishlist();

    if (!items.includes(handle)) {
      items.push(handle);
      saveWishlist(items);
    }

    return items;
  }

  function removeProduct(handle) {
    const items = getWishlist().filter(item => item !== handle);
    saveWishlist(items);
    return items;
  }

  function toggleProduct(handle) {
    if (hasProduct(handle)) {
      removeProduct(handle);
      return false;
    }

    addProduct(handle);
    return true;
  }

  function updateButtons() {
  document.querySelectorAll('[data-anaajoo-wishlist]').forEach(button => {
    const handle = button.dataset.anaajooWishlist;
    const active = hasProduct(handle);

    button.classList.toggle('is-wishlisted', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');

    const icon = button.querySelector('[data-wishlist-icon]');
    if (icon) {
      icon.setAttribute('fill', active ? 'currentColor' : 'none');
    }
  });

  const count = getWishlist().length;

  document.querySelectorAll('[data-anaajoo-wishlist-count]').forEach(bubble => {
    bubble.textContent = count > 99 ? '99+' : count;
    bubble.hidden = count === 0;
  });
}

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-anaajoo-wishlist]');

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const handle = button.dataset.anaajooWishlist;

    if (!handle) return;

    const addedToWishlist = toggleProduct(handle);

updateButtons();

/* ANA AJOO ANALYTICS — wishlist */
if (
  window.Shopify &&
  Shopify.analytics &&
  typeof Shopify.analytics.publish === 'function'
) {
  Shopify.analytics.publish(
    'anaajoo:wishlist_toggled',
    {
      product_handle: handle,
      action: addedToWishlist ? 'added' : 'removed',
      source: button.closest('#CartDrawer')
        ? 'cart_drawer'
        : 'storefront'
    }
  );
}
  });

  document.addEventListener('anaajoo:wishlist-updated', updateButtons);

document.addEventListener('DOMContentLoaded', function () {
  updateButtons();

  // Re-check wishlist hearts whenever Shopify redraws
  // product cards or the cart drawer.
  const wishlistObserver = new MutationObserver(function (mutations) {
    let wishlistButtonAdded = false;

    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;

        if (
          node.matches?.('[data-anaajoo-wishlist]') ||
          node.querySelector?.('[data-anaajoo-wishlist]')
        ) {
          wishlistButtonAdded = true;
          break;
        }
      }

      if (wishlistButtonAdded) break;
    }

    if (wishlistButtonAdded) {
      requestAnimationFrame(updateButtons);
    }
  });

  wishlistObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
});

window.AnaajooWishlist = {
    get: getWishlist,
    add: addProduct,
    remove: removeProduct,
    toggle: toggleProduct,
    has: hasProduct,
    refresh: updateButtons
  };
})();